<script>
import { filter } from 'lodash-es';

export default {
    props: {
        placeholder: {
            type: String,
            default: ''
        },
        items: {
            type: Array,
            required: true
        },
        values: {
            type: Array,
            required: true,
        },
        valueAttribute: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            toggled: false,
            index: -1,
            listIndex: -1,
            suggestion: undefined,
            list: [],
            noResult: false,
            input: ''
        }
    },
    methods: {
        toggle ($event) {
            if ($event.target.classList.contains('auto-complete-multi__input-field')) {
                this.toggled = !this.toggled;

                if (this.toggled) {
                    this.$nextTick(() => {
                        document.addEventListener('click', this.close);
                    });
                }
            }
        },
        filteredList () {
            return filter(this.items, (item) => {
                const inputLower = this.input ? this.input.toLowerCase() : '';
                let exist = filter(this.values, value => {
                    return value.name.toLowerCase() === item.name.toLowerCase();
                }).length > 0;
                return !exist && item.name && item.name.toLowerCase().indexOf(inputLower) === 0;
            });
        },
        clearInput () {
            document.getElementById('auto-complete-multi__input-field').value = '';
            this.input = '';
            this.toggled = false;
            this.index = -1;
            this.listIndex = -1;
            this.noResult = false;
            this.suggestion = undefined;
        },
        keys (key) {
            switch (key) {
            case 'ArrowDown':
                this.index < this.filteredList().length - 1 ? this.index++ : null;
                this.setSuggestion();
                this.scroll();
                break;
            case 'ArrowUp':
                this.index > -1 ? this.index-- : null;
                this.setSuggestion();
                this.scroll();
                break;
            case 'Escape':
                this.clearInput();
                document.getElementById('auto-complete-multi__input-field').blur();
                break;
            case 'Enter':
                if (this.listIndex !== -1) {
                    this.add(this.items[this.listIndex]);
                    this.clearInput();
                } else {
                    this.noResult = true;
                }
                break;
            case 'ArrowRight':
                document.getElementById('auto-complete-multi__input-field').value = this.suggestion.name;
                this.input = this.suggestion.name;
                break;
            case 'Backspace':
                this.noResult = false;
                break;
            default:
                this.toggled = true;
                break;
            }
        },
        fill (value) {
            this.input = value;
            if (value) {
                // Set the suggestion to first element that matches
                this.suggestion = this.filteredList()[0];
                // Set index to suggested value
                this.listIndex = this.suggestion ? this.items.indexOf(this.suggestion) : -1;
            } else {
                this.suggestion = undefined;
                this.listIndex = -1;
            }
        },
        add (value) {
            this.clearInput();
            this.$emit('add', value);
        },
        remove (index) {
            this.$emit('remove', index);
        },
        scroll() {
            let listElement = document.getElementById('auto-complete-multi__list');
            listElement.scrollTop = (this.index * 50) - 50;
        },
        close ($event) {
            this.toggled = false;
            $event.currentTarget.removeEventListener('click', this.close);
        },
        setSuggestion (){
            this.suggestion = this.filteredList()[this.index];
            this.listIndex = this.items.indexOf(this.suggestion);
        }
    }
}
</script>
<template>
    <div class="auto-complete-multi">
        <div class="auto-complete-multi__selected-items">
            <transition-group name="fade" tyep="in-out">
                <span v-for="(val, index) in values"
                      :key="'selected-items__' + index"
                      class="auto-complete-multi__item">
                    <i class="fa fa-times-circle auto-complete-multi__item-remove" @click="remove(index)"/> {{ val[valueAttribute] }}
                </span>
            </transition-group>
        </div>
        <div class="auto-complete-multi__input-fields">
            <input id="auto-complete-multi__input-field"
                   :class="{'auto-complete-multi__input-field--no-result': input && noResult}"
                   :placeholder="placeholder"
                   type="text"
                   class="auto-complete-multi__input auto-complete-multi__input-field"
                   @click="toggle($event)"
                   @input="fill($event.target.value)"
                   @keydown="keys($event.key)">
            <span v-if="suggestion && input" class="auto-complete-multi__input auto-complete-multi__input-pseudo">
                {{ suggestion.name }}
            </span>
        </div>
        <div class="auto-complete-multi__drop-down">
            <div v-if="toggled" id="auto-complete-multi__list" class="auto-complete-multi__list">
                <div v-for="(item, i) in filteredList()"
                     :class="{'auto-complete__choice--active' : i === index}"
                     :key="'choice__' + i"
                     class="auto-complete-multi__choice"
                     @click="add(item)">
                    {{ item.name }}
                    <span v-if="item.area"> ({{ item.area }})</span>
                </div>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/AutoCompleteMulti/AutoCompleteMulti.vue